import { Button } from "./Button";
import { Dialog } from "./Dialog";
import { Icon } from "./Icon";

/**
 * 统一的高风险操作确认界面。影响范围与不可逆结果必须在提交前明确展示，
 * 避免浏览器原生 confirm 无法承载审计语义和无障碍信息。
 */
export function ConfirmDialog({
  title,
  description,
  consequences,
  confirmLabel,
  busy = false,
  danger = true,
  onClose,
  onConfirm,
}: {
  readonly title: string;
  readonly description: string;
  readonly consequences?: readonly string[];
  readonly confirmLabel: string;
  readonly busy?: boolean;
  readonly danger?: boolean;
  readonly onClose: () => void;
  readonly onConfirm: () => void;
}) {
  return <Dialog busy={busy} description={description} eyebrow="CONFIRM ACTION" title={title} onClose={onClose}>
    <div className="confirm-dialog-content">
      <span className={`confirm-dialog-icon ${danger ? "danger" : "warning"}`}><Icon name="warning" /></span>
      <div><strong>请确认影响范围</strong>{consequences === undefined ? null : <ul>{consequences.map((item) => <li key={item}>{item}</li>)}</ul>}</div>
    </div>
    <footer className="dialog-actions">
      <Button disabled={busy} onClick={onClose}>取消</Button>
      <Button data-dialog-autofocus loading={busy} variant={danger ? "danger" : "primary"} onClick={onConfirm}>{confirmLabel}</Button>
    </footer>
  </Dialog>;
}
